import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';

import { LocationState } from '../types';

import axiosInstance from '../../../../api/axiosInstance';

const useGetImage = () => {
    const { state } = useLocation() as LocationState;

    const handleGetImage = () => {
        const params = {
            table_sys_id: state.incidentId
        }

        return axiosInstance('GET', '/v3_0_01/servicenow/incident/attachments', null, params, null, 'https://okuvoeaz9b.execute-api.eu-west-1.amazonaws.com');
    };

    return useQuery(['getImage', state.incidentId], handleGetImage, {
        enabled: !!state.incidentId,
        refetchOnWindowFocus: false,
    });
};

export default useGetImage;
